import { useCallback, useEffect } from "react";

export default function useSearchEffect(props) {
  const { callback, query } = props;

  const handler = () =>
    setTimeout(() => {
      callback();
    }, 1000);

  useEffect(() => {
    handler();

    return () => clearTimeout(handler);
  }, [query]);
}
